<div class="rating-call" [formGroup]="formGroup">
  @if (!isLoading) {
    <div class="rating-form">
      <app-doctor-card [doctor]="doctor" [patient]="patient" [call]="call"></app-doctor-card>
      @for (q of questions; track q; let first = $first) {
        <div class="rate-container" [class.border-none]="q.type === 'string'" [class.first-child]="first">
          <span class="title">{{ q.question }}</span>
          @if (q.type === 'number') {
            @if (getStarsForQuestion(q.id); as stars) {
              <div class="rate">
                @for (star of stars; track star; let i = $index) {
                  @if (stars.length === 10) {
                    <span
                      class="perfect-score"
                      [class.active]="(formGroup.get(q.id)?.value || 0) > i"
                      (click)="setRate(q.id, i + 1)"
                      >
                      {{ i + 1 }}
                    </span>
                  }
                  @if (stars.length === 5) {
                    <mat-icon
                      (click)="setRate(q.id, i + 1)"
                      [svgIcon]="(formGroup.get(q.id)?.value || 0) > i ? 'star-fill' : 'star-outline'"
                      >
                    </mat-icon>
                  }
                }
              </div>
            }
          }
          @if (q.type === 'string') {
            <mat-form-field class="textarea">
              <textarea matInput rows="7" [formControlName]="q.id" [placeholder]="'rate_text_placeholder' | locale"> </textarea>
            </mat-form-field>
          }
          @if (q.type === 'boolean') {
            <div class="question-buttons">
              <button
                mat-flat-button
                type="button"
                (click)="onBooleanQuestionClick(q.id, false)"
                [ngClass]="{ selected: formGroup.get(q.id)?.value === false }"
                >
                {{ 'no' | locale: null : true }}
              </button>
              <button
                mat-flat-button
                type="button"
                (click)="onBooleanQuestionClick(q.id, true)"
                [ngClass]="{ selected: formGroup.get(q.id)?.value === true }"
                >
                {{ 'yes' | locale: null : true }}
              </button>
            </div>
          }
        </div>
      }
      <div class="actions">
        <button mat-flat-button class="submit-btn" (click)="toggleFavoriteDoctor()">
          {{ (isFavoriteDoctor ? 'rate_doctor_remove_favorite' : 'rate_doctor_mark_favorite') | locale }}
          <mat-icon [svgIcon]="isFavoriteDoctor ? 'heart-filled' : 'heart-outline'" class="east"></mat-icon>
        </button>
      </div>
      <button mat-flat-button color="primary" class="submit-btn" (click)="submit()" [disabled]="formGroup.invalid">
        {{ 'default_send' | locale }}
        <mat-icon svgIcon="arrow-right" class="east"></mat-icon>
      </button>
    </div>
  }

  @if (!isLoading) {
    <app-footer></app-footer>
  }
</div>
